import React, { useState } from "react"
import styled from "styled-components"
import { useForm } from "react-hook-form"
import { NextPrevPost } from "./NextPrevPost"

type KlaviyoPayload = {
  email: string
}

export const Footer: React.FC = ({ settings }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const [isSuccessfullySubmitted, setIsSuccessfullySubmitted] =
    useState<boolean>(false)

  const onSubscribeToList = async (data: KlaviyoPayload): Promise<void> => {
    const { email } = data
    const newsletterPayload: { [key: string]: number | string } = {
      email: email,
    }
    const payloadEncoded = []
    for (const property in newsletterPayload) {
      const encodedKey = encodeURIComponent(property)
      const encodedValue = encodeURIComponent(newsletterPayload[property])
      payloadEncoded.push(encodedKey + "=" + encodedValue)
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        accept: "application/json",
      },
      body: payloadEncoded.join("&"),
    }

    const response = await fetch(
      "/.netlify/functions/subscribe",
      requestOptions
    )

    const responseJson = await response.json()

    if (responseJson.success === true) {
      setIsSuccessfullySubmitted(true)
    }
  }

  return (
    <>
      <FooterNextPrev>
        <NextPrevPost />
      </FooterNextPrev>
      <FooterWrapper className="footer grid grid-cols-16 pt-8 pb-24 bg-gray-light">
        <div className="footer__mark col-span-full mb-14">
          <svg
            width="160"
            height="14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m.104 11.824.507-.796c.155-.252.448-.332.665-.155.915.756 1.617 1.34 3.118 1.34 1.345 0 2.202-.818 2.202-1.805 0-1.164-1.013-1.902-2.944-2.698C1.663 6.874.104 5.844.104 3.592.104 2.075 1.272 0 4.372 0c1.95 0 3.41 1.009 3.606 1.146a.463.463 0 0 1 .115.663l-.488.734c-.155.253-.408.372-.683.195-.76-.486-1.501-.973-2.63-.973-1.638 0-2.202 1.03-2.202 1.748 0 1.106.857 1.787 2.477 2.446 2.26.911 4.192 1.981 4.192 4.348 0 2.018-1.812 3.671-4.347 3.671-2.377 0-3.881-1.242-4.192-1.534-.174-.152-.333-.289-.116-.62ZM10.274 5.242c0-.213.214-.429.427-.429h1.092c.236 0 .43.213.43.429v4.777c0 1.477.605 2.136 1.755 2.136 1.306 0 2.025-1.07 2.105-1.477V5.242c0-.371.177-.429.506-.429h.995c.235 0 .448.213.448.429v8.117c0 .234-.213.428-.448.428h-.467c-.235 0-.332-.155-.408-.37l-.235-.642C16.277 12.97 15.46 14 13.627 14c-2.69 0-3.353-1.769-3.353-4.118v-4.64ZM20.271 5.242c0-.213.196-.429.43-.429h.467c.196 0 .33.097.373.27l.271.779c.195-.235 1.23-1.243 3.02-1.243 2.749 0 3.49 1.902 3.49 4.233v4.503a.445.445 0 0 1-.43.429H26.8a.43.43 0 0 1-.427-.429V8.776c0-1.455-.604-2.31-1.776-2.31-1.421 0-2.242.992-2.376 1.301v5.592c0 .292-.156.428-.524.428h-.995a.433.433 0 0 1-.43-.428V5.242ZM30.091 13.085c-.137-.097-.253-.27-.155-.465l.408-.836c.098-.194.351-.252.586-.115.525.292 1.169.66 2.243.66.76 0 1.19-.368 1.19-.873 0-.601-.68-.99-1.928-1.552-1.385-.62-2.438-1.358-2.438-2.836 0-1.127.8-2.446 2.984-2.446 1.248 0 2.184.371 2.63.66.213.154.31.428.195.659l-.311.62c-.138.27-.41.252-.586.172-.622-.27-1.226-.446-1.928-.446-.781 0-1.15.389-1.15.796 0 .58.644.933 1.54 1.318 1.657.7 2.905 1.301 2.905 2.969 0 1.398-1.208 2.623-3.216 2.623a5.2 5.2 0 0 1-2.969-.908ZM37.845.62c0-.213.195-.43.43-.43h1.092c.214 0 .43.213.43.43v4.932c.214-.155 1.19-.933 2.612-.933 2.553 0 3.49 1.787 3.49 4.233v4.503a.445.445 0 0 1-.43.429h-1.093a.43.43 0 0 1-.426-.429v-4.54c0-1.476-.622-2.348-1.794-2.348-1.385 0-2.163.911-2.358 1.3v5.592c0 .252-.178.428-.449.428h-1.074a.433.433 0 0 1-.43-.428V.619ZM47.726 1.592c0-.738.564-1.318 1.287-1.318a1.309 1.309 0 1 1 0 2.62 1.287 1.287 0 0 1-1.287-1.302Zm.31 3.65c0-.213.196-.429.431-.429h1.092c.214 0 .43.213.43.429v8.117a.445.445 0 0 1-.43.428h-1.092a.433.433 0 0 1-.43-.428V5.242ZM52.226 5.242c0-.213.195-.429.43-.429h.467c.195 0 .332.097.368.27l.275.779c.196-.235 1.226-1.243 3.02-1.243 2.749 0 3.49 1.902 3.49 4.233v4.503a.445.445 0 0 1-.426.429h-1.093a.433.433 0 0 1-.43-.429V8.776c0-1.455-.604-2.31-1.772-2.31-1.425 0-2.243.992-2.376 1.301v5.592c0 .292-.156.428-.528.428h-.995a.433.433 0 0 1-.43-.428V5.242ZM66.356 4.622c2.34 0 4.112 1.726 4.112 4.118 0 .155-.018.465-.036.62a.42.42 0 0 1-.409.389h-6.217c.018 1.203 1.11 2.446 2.688 2.446 1.034 0 1.656-.367 2.202-.757.195-.136.369-.194.525.037l.528.817c.155.195.235.368-.04.602-.644.562-1.834 1.106-3.331 1.106-2.727 0-4.503-2.136-4.503-4.698-.004-2.525 1.772-4.68 4.481-4.68Zm2.181 3.69c-.04-1.089-.897-2.04-2.22-2.04-1.422 0-2.28.912-2.417 2.04h4.637ZM76.62.562c0-.195.156-.371.373-.371h7.797c.214 0 .373.173.373.371V1.65a.368.368 0 0 1-.373.367h-6.159V5.98h5.204c.196 0 .37.177.37.368v1.088a.373.373 0 0 1-.37.371h-5.204v4.175h6.16a.37.37 0 0 1 .372.368v1.066a.371.371 0 0 1-.373.371h-7.797a.371.371 0 0 1-.373-.37V.561ZM86.736 5.242c0-.213.195-.429.43-.429h.467c.195 0 .33.097.373.27l.27.779c.196-.235 1.23-1.243 3.02-1.243 2.75 0 3.49 1.902 3.49 4.233v4.503a.445.445 0 0 1-.43.429h-1.092a.43.43 0 0 1-.426-.429V8.776c0-1.455-.604-2.31-1.776-2.31-1.422 0-2.243.992-2.376 1.301v5.592c0 .292-.156.428-.525.428h-.998a.433.433 0 0 1-.43-.428V5.242h.003ZM100.979 4.622c1.403 0 2.437.526 3.273 1.553.177.213.115.465-.08.641l-.701.641c-.254.235-.431.058-.586-.097-.409-.447-1.132-.893-1.852-.893-1.54 0-2.727 1.243-2.727 2.835 0 1.61 1.168 2.853 2.669 2.853 1.168 0 1.638-.659 2.127-1.106.195-.194.408-.194.604-.04l.604.487c.213.195.311.407.155.641-.738 1.106-1.949 1.863-3.508 1.863-2.514 0-4.6-1.982-4.6-4.68.003-2.64 2.13-4.698 4.622-4.698ZM106.082.62c0-.213.195-.43.43-.43h1.093c.213 0 .426.213.426.43v12.735a.444.444 0 0 1-.426.429h-1.093a.433.433 0 0 1-.43-.429V.62ZM114.266 4.622c2.514 0 4.583 2.137 4.583 4.658 0 2.562-2.065 4.72-4.583 4.72-2.531 0-4.6-2.154-4.6-4.72 0-2.525 2.069-4.658 4.6-4.658Zm0 7.533c1.501 0 2.67-1.224 2.67-2.875 0-1.61-1.169-2.813-2.67-2.813-1.519 0-2.687 1.203-2.687 2.813 0 1.65 1.168 2.875 2.687 2.875ZM120.151 13.085c-.138-.097-.253-.27-.156-.465l.409-.836c.098-.194.351-.252.586-.115.528.292 1.168.66 2.242.66.76 0 1.19-.368 1.19-.873 0-.601-.683-.99-1.931-1.552-1.382-.62-2.434-1.358-2.434-2.836 0-1.127.799-2.446 2.98-2.446 1.248 0 2.184.371 2.633.66.213.154.311.428.195.659l-.311.62c-.137.27-.409.252-.586.172-.622-.27-1.229-.446-1.931-.446-.781 0-1.15.389-1.15.796 0 .58.644.933 1.541 1.318 1.656.7 2.904 1.301 2.904 2.969 0 1.398-1.208 2.623-3.216 2.623a5.192 5.192 0 0 1-2.965-.908ZM127.808 5.242c0-.213.213-.429.43-.429h1.092c.235 0 .427.213.427.429v4.777c0 1.477.604 2.136 1.754 2.136 1.306 0 2.026-1.07 2.105-1.477V5.242c0-.371.174-.429.506-.429h.995c.235 0 .448.213.448.429v8.117c0 .234-.213.428-.448.428h-.467c-.235 0-.329-.155-.408-.37l-.235-.642c-.196.195-1.013 1.225-2.847 1.225-2.687 0-3.352-1.769-3.352-4.118v-4.64ZM137.804 5.242c0-.213.195-.429.43-.429h.467c.177 0 .35.137.39.31l.253.814c.156-.234 1.093-1.318 2.727-1.318.858 0 1.928.234 1.639.835l-.467.97c-.119.252-.351.31-.546.212-.137-.08-.546-.173-.821-.173-1.324 0-2.047 1.049-2.123 1.204v5.688c0 .39-.253.429-.622.429h-.897a.433.433 0 0 1-.43-.429V5.242ZM148.524 4.622c2.34 0 4.112 1.726 4.112 4.118 0 .155-.018.465-.036.62a.421.421 0 0 1-.409.389h-6.221c.018 1.203 1.111 2.446 2.688 2.446 1.034 0 1.656-.367 2.202-.757.195-.136.369-.194.525.037l.528.817c.155.195.235.368-.04.602-.644.562-1.834 1.106-3.331 1.106-2.727 0-4.503-2.136-4.503-4.698 0-2.525 1.776-4.68 4.485-4.68Zm2.181 3.69c-.04-1.089-.897-2.04-2.221-2.04-1.421 0-2.279.912-2.416 2.04h4.637ZM153.823 13.085c-.138-.097-.254-.27-.156-.465l.409-.836c.097-.194.351-.252.586-.115.524.292 1.168.66 2.242.66.76 0 1.19-.368 1.19-.873 0-.601-.68-.99-1.928-1.552-1.385-.62-2.437-1.358-2.437-2.836 0-1.127.799-2.446 2.983-2.446 1.248 0 2.185.371 2.63.66.213.154.311.428.195.659l-.311.62c-.137.27-.409.252-.586.172-.622-.27-1.226-.446-1.928-.446-.781 0-1.15.389-1.15.796 0 .58.644.933 1.541 1.318 1.656.7 2.904 1.301 2.904 2.969 0 1.398-1.208 2.623-3.215 2.623a5.196 5.196 0 0 1-2.969-.908Z"
              fill="#000"
            />
          </svg>
        </div>
        <div className="footer__locations col-span-full md:col-span-7">
          <FooterHeading className="font-fp-light mb-5">
            Locations
          </FooterHeading>
          <div className="flex flex-row flex-wrap gap-y-6">
            <div className="footer__locations--item w-1/2 md:w-4/12 font-fp-regular">
              {settings?.first_location?.content && (
                <>
                  <FooterLocationHeading className="font-fp-light  mb-1">
                    New York
                  </FooterLocationHeading>
                  <FooterLocationAddress
                    dangerouslySetInnerHTML={{
                      __html: settings?.first_location?.content,
                    }}
                  />
                </>
              )}
            </div>
            <div className="footer__locations--item w-1/2 md:w-4/12 font-fp-regular">
              {settings?.second_location?.content && (
                <>
                  <FooterLocationHeading className="font-fp-light mb-1">
                    Los Angeles
                  </FooterLocationHeading>
                  <FooterLocationAddress
                    dangerouslySetInnerHTML={{
                      __html: settings?.second_location?.content,
                    }}
                  />
                </>
              )}
            </div>
            <div className="footer__locations--item w-1/2 md:w-4/12 font-fp-regular">
              {settings?.third_location?.content && (
                <>
                  <FooterLocationHeading className="font-fp-light  mb-1">
                    China
                  </FooterLocationHeading>
                  <FooterLocationAddress
                    dangerouslySetInnerHTML={{
                      __html: settings?.third_location?.content,
                    }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
        <FooterContact className="footer__contact font-fp-regular col-span-full mt-6 md:mt-0 md:col-span-4">
          <FooterHeading className="font-fp-light">Contact</FooterHeading>
          <div className="footer__contact--details">
            {settings?.contact_email_label ? (
              settings?.contact_email ? (
                <a href={`${settings?.contact_email}`}>
                  {settings?.contact_email_label}
                </a>
              ) : (
                <span>{settings?.contact_email_label}</span>
              )
            ) : null}
            {settings?.contact_numbers && (
              <div
                className="footer__contact--numbers"
                dangerouslySetInnerHTML={{
                  __html: settings?.contact_numbers?.content,
                }}
              ></div>
            )}
          </div>
          <FooterHeading className="font-fp-light mt-6">Connect</FooterHeading>
          <div className="footer__contact--social">
            <ul>
              {settings?.linkedin ? (
                <li>
                  <a target="_blank" href={settings?.linkedin} rel="noreferrer">
                    Linkedin
                  </a>
                </li>
              ) : null}
              {settings?.instagram ? (
                <li>
                  <a
                    target="_blank"
                    href={settings?.instagram}
                    rel="noreferrer"
                  >
                    Instagram
                  </a>
                </li>
              ) : null}
            </ul>
          </div>
        </FooterContact>
        <FooterSubscribe className="footer__subscribe font-fp-regular col-span-full mt-6 md:mt-0 md:col-span-5">
          <FooterHeading className="font-fp-light">Newsletter</FooterHeading>
          <div className="footer__subscribe--form-wrapper">
            {isSuccessfullySubmitted ? (
              <p>You are now subscribed to our email list!</p>
            ) : (
              <form
                className="footer__subscribe--form flex flex-col"
                method="POST"
                onSubmit={handleSubmit(onSubscribeToList)}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  {...register("email", { required: true })}
                />
                {errors.firstName && <p>Please check the email you entered</p>}
                <input
                  className="footer__subscribe--form-submit bg-yellow-regular mt-9 ml-auto w-24"
                  type="submit"
                  value="Submit"
                />
              </form>
            )}
          </div>
        </FooterSubscribe>
        {settings?.jobs_visibility !== true && (
          <FooterJobs className="footer__jobs col-span-full md:col-span-3">
            <FooterHeading className="mt-6">Jobs</FooterHeading>
            <div className="footer__jobs--intro font-fp-regular flex flex-col">
              <span>
                Come work with us! We are always looking for great talent to
                join our global teams.
              </span>
              <a className="footer__jobs--listing w-24 ml-auto text-center rounded-full bg-yellow-regular">
                See Jobs
              </a>
            </div>
          </FooterJobs>
        )}
      </FooterWrapper>
    </>
  )
}

const FooterNextPrev = styled.div``

const FooterWrapper = styled.div`
  padding-left: 25px;
  padding-right: 25px;

  .footer__mark {
    margin-bottom: 50px;
  }
`

const FooterHeading = styled.h4`
  font-family: "Favorit Pro Light";
  font-size: 1.25rem;
  line-height: 1.5rem;
  text-transform: none;
  letter-spacing: 0;
  margin-bottom: 1.125rem;
`

const FooterLocationHeading = styled.h5`
  font-family: "Favorit Pro Light";
  font-size: 0.8125rem;
  line-height: 1.375rem;
  text-transform: uppercase;
  letter-spacing: 0;
`

const FooterContact = styled.div`
  .footer__contact--details {
    * {
      font-family: "Favorit Pro Regular";
    }
    ul {
      margin-top: 30px;
    }
    ul li {
      margin: 0px;
      font-size: 0.9375rem;
      line-height: 1.375rem;
    }
  }

  .footer__contact--social {
    ul li {
      margin: 0px;
      font-size: 0.9375rem;
      line-height: 1.375rem;
    }
  }

  a {
    box-shadow: none;
  }
`

const FooterLocationAddress = styled.div`
  font-family: "Favorit Pro Regular";
  padding-right: 20px;
  font-size: 0.9375rem;
  line-height: 1.375rem;
`

const FooterSubscribe = styled.div`
  [type="email"] {
    font-family: "Favorit Pro Regular";
    font-size: 0.9375rem;
    line-height: 1.375rem;
    background: transparent;
    border-bottom: 1px solid #000000;

    &:focus {
      outline: none;
      background: transparent;
    }

    &::placeholder {
      color: #aaaaaa;
    }
  }

  .footer__subscribe--form-submit {
    font-size: 0.9375rem;
    line-height: 1.375rem;
    font-family: "Favorit Pro Regular";
    padding: 12px 18px;
    border-radius: 7px;
    cursor: pointer;
    border-radius: 25px;

    @media (min-width: 768px) {
      border-radius: 22px;
    }
  }
`

const FooterJobs = styled.div`
  .footer__jobs--intro {
    font-size: 0.9375rem;
    line-height: 1.375rem;
    font-family: "Favorit Pro Regular";
  }
  .footer__jobs--listing {
    font-size: 0.9375rem;
    line-height: 1.375rem;
    font-family: "Favorit Pro Regular";
    padding: 12px 18px;
    border-radius: 7px;
    box-shadow: none;
    margin-top: 16px;

    @media (min-width: 768px) {
      border-radius: 22px;
    }
  }
`
